'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    fill: "currentColor",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.092 17.507c-.433-.428-.975-.428-1.406 0-.329.326-.657.652-.98.983-.089.091-.163.11-.271.05-.213-.116-.44-.21-.644-.337-.953-.6-1.751-1.37-2.458-2.237-.351-.431-.663-.893-.881-1.412-.045-.105-.036-.174.05-.26.328-.317.648-.643.972-.97.45-.452.45-.983-.003-1.438-.257-.26-.514-.514-.77-.774-.266-.265-.528-.533-.796-.795-.434-.423-.976-.423-1.406.002-.332.326-.65.66-.987.981a1.6 1.6 0 0 0-.502 1.08c-.053.688.116 1.337.353 1.97.486 1.309 1.227 2.472 2.124 3.538a13.145 13.145 0 0 0 4.354 3.406c.762.37 1.552.655 2.411.702.592.033 1.105-.116 1.517-.578.282-.315.6-.602.898-.903.442-.448.445-.989.005-1.43-.525-.528-1.052-1.053-1.58-1.578Z",
    fill: "#FFF"
  })));
});
var PhoneCircled = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.PhoneCircled = PhoneCircled;